import { render, staticRenderFns } from "./booking-page.vue?vue&type=template&id=422dac7c&scoped=true&"
import script from "./booking-page.vue?vue&type=script&lang=js&"
export * from "./booking-page.vue?vue&type=script&lang=js&"
import style0 from "./booking-page.vue?vue&type=style&index=0&id=422dac7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422dac7c",
  null
  
)

export default component.exports